import { UseMutationProps } from "@lib/types/Api";
import { Provider, ProviderCustomerMatrix } from "@lib/types/Provider";
import { Modal } from "antd";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import useIntl from "react-intl/lib/src/components/useIntl";
import ProviderCustomerMatrixForm from "../ProviderCustomerMatrixForm";
import { Customer } from "@lib/types/Customer";

type Props = {
  openModal: boolean;
  toggleModal: (status?: boolean) => void;
  mutationQuery: UseMutationProps<ProviderCustomerMatrix>;
  providerMatrix?: ProviderCustomerMatrix;
  defaultProvider?: Provider;
  defaultCustomer?: Customer;
  defaultMatrix?: ProviderCustomerMatrix;
};

export default function ProviderCustomerMatrixModal(props: Props) {
  const { messages } = useIntl();
  const { openModal, toggleModal, providerMatrix } = props;

  const handleClose = useCallback(() => {
    toggleModal(false);
  }, [toggleModal]);

  return (
    <Modal
      title={
        <FormattedMessage
          id={providerMatrix ? "common.editTitle" : "common.createTitle"}
          values={{
            title: messages["common.apiKey"] as string,
          }}
        />
      }
      open={openModal}
      onCancel={handleClose}
      footer={null}
      width={{
        xs: "90%",
        sm: "80%",
        md: "70%",
        lg: "60%",
        xl: "50%",
        xxl: "40%",
      }}
    >
      <ProviderCustomerMatrixForm
        {...props}
        openModal={openModal}
        handleClose={handleClose}
        providerMatrix={providerMatrix}
      />
    </Modal>
  );
}
